import React, { useEffect, useState } from 'react';
import api from '../../lib/api';

/**
 * EngineeringLogs — recent system_recovery events + memory timeline.
 */
export default function EngineeringLogs() {
  const [logs, setLogs] = useState(null);
  useEffect(() => {
    api.get('/lab/logs?limit=40').then(({ data }) => setLogs(data)).catch(() => {});
  }, []);
  if (!logs) return <div className="p-4 text-[11px] text-[var(--txt-secondary)]">loading…</div>;

  return (
    <div data-testid="lab-logs" className="grid md:grid-cols-2 gap-3">
      <div className="border border-[var(--border-default)] p-3">
        <div className="text-[10px] tracking-[0.25em] uppercase text-cyan-sys mb-2">// system recoveries</div>
        <div className="text-[10px] font-mono space-y-1">
          {(logs.recoveries || []).length === 0 && <div className="text-[var(--txt-secondary)]">none recorded</div>}
          {(logs.recoveries || []).map((r) => (
            <div key={r.id} className="border-l-2 border-cyan-sys pl-2">
              <div className="text-[var(--txt-primary)]">{r.event}</div>
              <div className="text-[9px] text-[var(--txt-secondary)]">
                {(r.timestamp || '').replace('T', ' ').slice(0, 19)}Z ·
                jobs={r.jobs_resumed}/{r.jobs_retried}/{r.jobs_failed} ·
                positions={r.open_positions}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="border border-[var(--border-default)] p-3">
        <div className="text-[10px] tracking-[0.25em] uppercase text-cyan-sys mb-2">// memory timeline</div>
        <div className="text-[10px] font-mono space-y-1">
          {(logs.memory || []).map((m) => (
            <div key={m.id} className="border-l-2 border-[var(--border-default)] pl-2">
              <div className="text-[var(--txt-primary)]">{m.title}</div>
              <div className="text-[9px] text-[var(--txt-secondary)]">
                {m.kind} · {(m.timestamp || '').slice(0, 10)}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
